import dayjs from 'dayjs';
import isBetween from 'dayjs/plugin/isBetween';

import { getIsMobileScreen } from '@client/redux/modules/clientDevice';
import { useSelector } from 'react-redux';
import {
    getCategoryTabId,
    getGlobalRetailEvents,
    getGRETab,
    getGRETabCampaigns,
} from '@client/redux/modules/mylounge';
import { useConfig } from '@browsing/config';
import { CategoryTabIds } from '@shared/constants';
import { Campaign, CategoryTab, GlobalRetailEvent } from '@shared/types/mylounge';

dayjs.extend(isBetween);

export interface GREHookResponse {
    shouldRenderGRECarousel: boolean;
    shouldRenderGRETabHeader: boolean;
    greData: GlobalRetailEvent | undefined;
    isGREEnabled: boolean;
    greTabData: CategoryTab | undefined;
    greCarouselCampaigns: Campaign[] | undefined;
    checkIfGRETab: (tab: CategoryTab) => boolean;
    isCyberWeek: boolean;
}

const GRE_CAROUSEL_LENGTH = 6;

export function getIsCyberWeek(startDate: string, endDate: string): boolean {
    const currentDate = dayjs();
    const startTarget = dayjs(startDate);
    const endTarget = dayjs(endDate);
    return currentDate.isBetween(startTarget, endTarget, 'day', '[]');
}

export const findCampaignWithoutLogo = (campaigns: Campaign[]) =>
    campaigns?.find(campaign => !campaign.hasLogo);

export const useGRE = (): GREHookResponse => {
    const isMobileScreen = useSelector(getIsMobileScreen);
    const categoryTabId = useSelector(getCategoryTabId);

    const greTab = useSelector(getGRETab);
    const greTabCampagins = useSelector(getGRETabCampaigns);
    const campaignRange = Math.min(GRE_CAROUSEL_LENGTH, greTabCampagins?.length);
    const greCarouselCampaignsWithoutAll = greTabCampagins?.slice(0, campaignRange).reverse();
    const campaignsForFindingWithoutLogo =
        greTabCampagins.length > campaignRange
            ? greTabCampagins?.slice(campaignRange)
            : greTabCampagins;

    const campaignForAllCard = findCampaignWithoutLogo(campaignsForFindingWithoutLogo);

    const greCarouselCampaigns = [...greCarouselCampaignsWithoutAll, campaignForAllCard];
    const globalRetailEvent = useSelector(getGlobalRetailEvents)?.[0];
    const config = useConfig();
    const isGREConfigEnabled = config.isEnabled('greRedesign');
    const isGREEnabled = isGREConfigEnabled && isMobileScreen;
    const isMainTab = categoryTabId === CategoryTabIds.ALL;

    const shouldRenderGRECarousel =
        isMainTab &&
        isGREConfigEnabled &&
        globalRetailEvent &&
        greCarouselCampaigns &&
        isMobileScreen;

    const shouldRenderGRETabHeader = isGREEnabled && !!globalRetailEvent;

    const checkIfGRETab = (tab: CategoryTab) => {
        if (!isGREEnabled) return false;

        return tab?.globalRetailEvent && tab.id !== CategoryTabIds.ALL;
    };

    return {
        shouldRenderGRECarousel,
        shouldRenderGRETabHeader,
        greData: globalRetailEvent,
        isGREEnabled,
        greTabData: greTab,
        greCarouselCampaigns,
        checkIfGRETab,
        isCyberWeek: getIsCyberWeek('2025-11-16', '2025-12-01'),
    };
};
